import React, { useState, useEffect, useRef } from "react"
import { useNavigate } from "react-router"
import {
  SellDetailsContainer,
  CommentContainer,
  MoreDetailWrapper,
  MenuList,
  IconLabelWrapper,
  SvgWrapper
} from "./styles"

import { useAuth } from '../../contexts/AuthContext'
import CommentTab from "../Shared/CommentTab"
import UserAvatar from "../Shared/UserAvatar"
import {
  HeartOutlineIcon,
  HeartFillIcon,
  ItemsIcon,
  UserListIcon,
  MoreDetailIcon
} from "../Shared/SvgIcons"
import MainModal from "../Shared/MainModal"
import { OwnedBy } from "../Shared/OwnedBy"

import useToast from "../../hooks/useToast"
import { useGlobal } from "../../contexts/GlobalContext"
import { useCustomWallet } from "../../contexts/WalletContext"
import { useNFTItem } from "../../contexts/NFTContext"

export const CollectionItem = () => {
  const navigate = useNavigate()
  const { auth } = useAuth()
  const { wallet } = useCustomWallet()
  const { itemLoaded, favorite, creatorInfo, nftSale, comments, requestReloadNFT } = useNFTItem()
  const { showLoading, hideLoading, toastSuccess, toastError, toastInfo } = useToast()
  const { invokeServer, copyToClipboard, refreshPage } = useGlobal()

  const [isMenu, setIsMenu] = useState(false)
  const [isImage, setIsImage] = useState(true)
  const [isOwnedModal, setIsOwnedModal] = useState(false)
  const [activeTab, setActiveTab] = useState('Direct Sale')
  
  const sellTypes = ['Direct Sale', 'Auctions', 'Stats', 'Properties', 'Details', 'Settings']

  const videoRef = useRef()
  const moreDetailRef = useRef()

  const handleClickOutside = (e) => {
    if (!isMenu) return
    const outSideMenu = !moreDetailRef.current?.contains(e.target)
    if (outSideMenu) {
      setIsMenu(false)
    }
  }

  const reloadInfoFunc = () => {
    requestReloadNFT(itemLoaded.collectionAddress, itemLoaded.tokenId);
  }

  const handleSetFavorite = (t) => {
    if (t === true) {
      showLoading('Setting favorite...');

      invokeServer('put', '/api/favorite', {
        contract: itemLoaded.collectionAddress,
        tokenId: itemLoaded.tokenId,
        name: auth.loggedUserName,
        address: wallet.address,
        update: true
      })
        .then(r => {
          hideLoading()
          if (r.data.result === 1) {
            requestReloadNFT(itemLoaded.collectionAddress, itemLoaded.tokenId)
            toastSuccess('Favorite', 'added')
          } else {
            toastError('Favorite', 'failed to add')
          }
        })
        .catch(err => {
          hideLoading()
          toastError('Favorite', err.message)
        })
    } else {
      showLoading('Removing favorite...')

      invokeServer('put', '/api/favorite', {
        contract: itemLoaded.collectionAddress,
        tokenId: itemLoaded.tokenId,
        name: auth.loggedUserName,
        address: wallet.address,
        update: false
      })
        .then(r => {
          hideLoading()
          if (r.data.result === 1) {
            requestReloadNFT(itemLoaded.collectionAddress, itemLoaded.tokenId)
            toastSuccess('Favorite', 'removed')
          } else {
            toastError('Favorite', 'failed to remove')
          }
        })
        .catch(err => {
          hideLoading()
          toastError('Favorite', err.message)
        })
    }
  }

  const handleShare = () => {
    copyToClipboard(window.location.href)
    toastInfo('Copy to clipboard', window.location.href)
  }

  const handleRefresh = () => {
    refreshPage()
    toastInfo('Refresh', 'Page refreshing...')
  }

  const handleReport = () => {
    // Add commnet submit function
    if (itemLoaded.collectionAddress === undefined)
      return

    showLoading('Reporting...')
    invokeServer('post', '/api/comment', {
      collectionAddress: itemLoaded.collectionAddress,
      tokenId: itemLoaded.tokenId,
      content: `${auth.loggedUserName} reported`,
      user: auth.loggedUserName,
      address: wallet.address,
      role: auth.loggedUserRole,
    })
      .then(r => {
        if (r.data.result === 1) {
          hideLoading()
          toastSuccess(auth.loggedUserName, 'Successfully reported')
          reloadInfoFunc()
        }
      })
      .catch(err => {
        hideLoading()
        toastError(auth.loggedUserName, 'Failed to report')
      })
  }

  useEffect(() => {
    setIsImage(itemLoaded?.video === true ? false : true)
  }, [itemLoaded])

  useEffect(() => {
    if (isImage) return
    videoRef.current.play()
  }, [isImage])

  useEffect(() => {
    window.addEventListener('click', handleClickOutside)
    return () => window.removeEventListener('click', handleClickOutside)
  }, [isMenu])

  return (
    <SellDetailsContainer>
      <div className="item-container">
        <div className="media-container">
          {isImage ? (
            <div className="image">
              <img src={itemLoaded?.image} alt='product' />
            </div>
          ) : (
            <div className="media">
              <video src={itemLoaded?.image} preload="auto" autoPlay controls loop muted ref={videoRef}></video>
            </div>
          )}
        </div>
        <div className="detail-container">
          <div className="about-container">
            <div className="title-container">
              <div>
                <div className="nft-title">{itemLoaded?.title}</div>
                <div className="nft-review">
                  <IconLabelWrapper>
                    <ItemsIcon />
                    <span>{itemLoaded?.totalSupply} {itemLoaded?.totalSupply <= 1 ? 'copy' : 'copies'}</span>
                  </IconLabelWrapper>
                  <IconLabelWrapper className="owned-by" onClick={() => setIsOwnedModal(true)}>
                    <UserListIcon />
                    <span>{itemLoaded?.holderCount} owner{itemLoaded?.holderCount <= 1 ? '' : 's'}</span>
                  </IconLabelWrapper>
                  <IconLabelWrapper>
                    {favorite && (favorite.set === true ? (
                      <SvgWrapper
                        onClick={() => handleSetFavorite(false)}
                      >
                        <HeartFillIcon />
                      </SvgWrapper>
                    ) : (
                      <SvgWrapper
                        onClick={() => {
                          handleSetFavorite(true)
                        }}
                      >
                        <HeartOutlineIcon />
                      </SvgWrapper>
                    ))}
                    <span>{favorite?.count} favorite{favorite?.count <= 1 ? '' : 's'}</span>
                  </IconLabelWrapper>
                </div>
              </div>
              <div className="user-detail">
                <div onClick={() => navigate(`/profile/${creatorInfo?.address}`)}>
                  <div className="username-label"><span>CREATOR</span> {creatorInfo?.name}</div>
                  <div className="username-value"><span>COLLECTION NAME</span> {itemLoaded?.collectionName}</div>
                </div>
                <div onClick={() => navigate(`/profile/${creatorInfo?.address}`)}>
                  {
                    creatorInfo.avatarURI && creatorInfo.avatarURI !== '' ?
                      <img src={creatorInfo.avatarURI} alt='' /> :
                      <UserAvatar />
                  }
                </div>
                <MoreDetailWrapper>
                  <span onClick={() => setIsMenu(true)} ref={moreDetailRef}>
                    <MoreDetailIcon />
                  </span>

                  {isMenu && (
                    <MenuList>
                      <div onClick={handleShare}>Share</div>
                      <div onClick={handleRefresh}>Refresh</div>
                      { wallet.address? <div onClick={handleReport}>Report</div> : <></>}
                    </MenuList>
                  )}
                </MoreDetailWrapper>
              </div>
            </div>
            <div className="description-container">
              {itemLoaded?.description && (
                <p className="description-content">
                  {itemLoaded?.description}
                </p>
              )}
            </div>
          </div>
          <CommentContainer>
            <CommentTab types={sellTypes} active={activeTab} setActive={setActiveTab} sales={nftSale} nftItem={itemLoaded} comments={comments} refresh={reloadInfoFunc} />
          </CommentContainer>
        </div>
      </div>

      {isOwnedModal && (
        <MainModal
          title={'Owned by'}
          icon={<UserListIcon />}
          width={'556px'}
          height={'auto'}
          handleClose={() => setIsOwnedModal(false)}>
          <OwnedBy collection={itemLoaded?.collectionAddress} tokenId={itemLoaded?.tokenId}/>
        </MainModal>
      )}
    </SellDetailsContainer>
  )
}
